import { render } from "./price.vue?vue&type=template&id=300821b4&scoped=true"
import script from "./price.vue?vue&type=script&lang=js"
export * from "./price.vue?vue&type=script&lang=js"

import "./price.vue?vue&type=style&index=0&id=300821b4&scoped=true&lang=css"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300821b4"]])

export default __exports__